import React from "react";
import { CheckCircle, AlertCircle, Info, AlertTriangle } from "lucide-react";

// Herbruikbaar bevestigings-/resultaatpaneel: een gekleurde icooncirkel, titel,
// omschrijving en optionele acties. Gebruikt voor o.a. e-mailverificatie en de
// afronding van een aanmelding, zodat die schermen dezelfde UX delen.
const variants = {
  success: { Icon: CheckCircle, ring: "bg-success/10", color: "text-success" },
  error: { Icon: AlertCircle, ring: "bg-error/10", color: "text-error" },
  warning: { Icon: AlertTriangle, ring: "bg-warning/10", color: "text-warning" },
  info: { Icon: Info, ring: "bg-accent-subtle", color: "text-accent" },
};

function StatusPanel({ variant = "success", icon: IconOverride, title, description, children, actions, card = false }) {
  const cfg = variants[variant] || variants.success;
  const Icon = IconOverride || cfg.Icon;

  return (
    <div className={["text-center animate-fade-in", card ? "card p-6" : ""].filter(Boolean).join(" ")}>
      <div className={["w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center", cfg.ring].join(" ")}>
        <Icon size={28} strokeWidth={1.5} className={cfg.color} />
      </div>
      {title && <h2 className="text-2xl font-heading font-bold mb-2">{title}</h2>}
      {description && <p className="text-sm text-text-secondary mb-6">{description}</p>}
      {children}
      {actions && <div className="flex flex-col sm:flex-row items-center justify-center gap-3">{actions}</div>}
    </div>
  );
}

export default StatusPanel;
